<template>
  <div
    v-if="globalCompanyPermission && globalUserPermission"
    class="grid-cell"
  >
    <router-link
      :id="`gridNameEditor${data.id}`"
      :to="{name: 'TemplateDetailsSummary', query: {
        externalId: $route.query.externalId,
        clientId: $route.query.clientId,
        templateId: data.id,
        isSearchingTemplate: $route.query.isSearchingTemplate,
        isCreatingCampaign: $route.query.isCreatingCampaign,
        canCreateTemplate: $route.query.canCreateTemplate,
        userEmail: $route.query.userEmail} }"
    >
      <span class="grid-cell--title">{{ data.name }}</span><br>
    </router-link>
  </div>
  <div
    v-else
    class="grid-cell"
  >
    <span class="grid-cell--title">{{ data.name }}</span><br>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      editorsTypes: state => state.templateBuilder.editorsTypes
    }),
    ...mapGetters({
      accountId: 'getAccountId',
      globalCompanyPermission: 'getGlobalCompanyPermission',
      globalUserPermission: 'getGlobalUserPermission'
    }),
    editorTypeDescription () {
      if (this.editorsTypes && this.data.editorTypeId) {
        return this.editorsTypes.find(e => e.id === this.data.editorTypeId)?.description
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
.grid-cell {
  overflow: hidden;
  text-overflow: ellipsis;
}
.grid-cell--title {
  color: #000;
}
.grid-cell--subtitle {
  color: #666;
}
</style>
